
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-offers/[id]/preview/[previewId]",
      function () {
        return require("private-next-pages/job-offers/[id]/preview/[previewId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-offers/[id]/preview/[previewId]"])
      });
    }
  